/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Never_TitleInputs */

const en_bot_never_title = /** @type {(inputs: Bot_Never_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it never does`)
};

const id_bot_never_title = /** @type {(inputs: Bot_Never_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang tidak pernah dilakukan`)
};

/**
* | output |
* | --- |
* | "What it never does" |
*
* @param {Bot_Never_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_never_title = /** @type {((inputs?: Bot_Never_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Never_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_never_title(inputs)
	return en_bot_never_title(inputs)
});